import React from "react";

const TemarioDiplomaturaMicrotrasplanteCapilar = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Fundamentos y Ciencias Básicas"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Historia del trasplante capilar"}</span></li>
                <li><span className="fw-light">{"Anatomía y estructura folicular"}</span></li>
                <li><span className="fw-light">{"Anatomía topográfica del cuero cabelludo aplicada"}</span></li>
                <li><span className="fw-light">{"Ciclos de crecimiento del cabello"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Tricología Clínica y Diagnóstico"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Causas de alopecia"}</span></li>
                <li><span className="fw-light">{"Tipos de alopecias y su clasificación en hombres y mujeres"}</span></li>
                <li><span className="fw-light">{"Conceptos de densidad capilar"}</span></li>
                <li><span className="fw-light">{"Diagnóstico y estudios complementarios"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"El Paciente y la Consulta Médica"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Manejo de la consulta y psicología del paciente"}</span></li>
                <li><span className="fw-light">{"Expectativas, limitaciones de la técnica y consentimiento informado"}</span></li>
                <li><span className="fw-light">{"Historia clínica y registro fotográfico"}</span></li>
                <li><span className="fw-light">{"Indicaciones previas y contraindicaciones"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Terapéutica Médica No Quirúrgica"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Tratamientos farmacológicos: Finasteride y Minoxidil"}</span></li>
                <li><span className="fw-light">{"Bioestimulación: Mesoterapia, PRP y estimulación capilar"}</span></li>
                <li><span className="fw-light">{"Resultados a largo plazo y mantenimiento del paciente no quirúrgico"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Planificación Quirúrgica e Instrumentación"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Preparación y planificación del procedimiento"}</span></li>
                <li><span className="fw-light">{"Diseño del área donante y determinación de áreas seguras"}</span></li>
                <li><span className="fw-light">{"Estrategias de diseño del área receptora: línea frontal masculina y femenina"}</span></li>
                <li><span className="fw-light">{"Insumos e instrumental requerido"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Técnicas de Extracción (FUE - FUSS)"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Técnicas de anestesia local y tumescencia"}</span></li>
                <li><span className="fw-light">{"Técnica FUE (Follicular Unit Extraction)"}</span></li>
                <li><span className="fw-light">{"Técnica FUSS (Strip/Tira)"}</span></li>
                <li><span className="fw-light">{"Extracción y valoración de la calidad de las unidades foliculares"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Fase de Implantación y Diseño"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Incisiones en el área receptora: ángulos y direcciones"}</span></li>
                <li><span className="fw-light">{"Técnicas de colocación de injertos: implanters vs. pinzas"}</span></li>
                <li><span className="fw-light">{"Redistribución capilar y densidad estética"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Postoperatorio y Cierre del Programa"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Indicaciones post trasplante y cuidados críticos"}</span></li>
                <li><span className="fw-light">{"Manejo de complicaciones potenciales"}</span></li>
                <li><span className="fw-light">{"Conclusiones y recomendaciones finales para la práctica profesional"}</span></li>
                <li><span className="fw-light">{"Práctica final hands-on sobre pacientes reales"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaMicrotrasplanteCapilar;
